module.exports = __webpack_public_path__ + "img/tubone.f6222053.jpg";